import { createAction, props } from '@ngrx/store';
import { ActionResponse } from 'src/app/models/action-response';
import { EntityAddRequest } from 'src/app/models/entity';

export const selectEntites = createAction('[Wizard Selection Step] Select Modify Type Asset Step', props<{ bulkSearchStep: any[] }>());

export const exitModifyTypeWizard = createAction('[ModifyType Wizard Page] Exit Modify Type Wizard');

export const destroyWizard = createAction('[ModifyType Wizard Page] Destroy Wizard');

export const createNewModifyType = createAction(
  '[Wizard Confirmation Step] Create Modify Type Information Step',
  props<{ request: EntityAddRequest; typeKind: string; entityKind: string }>(),
);

export const createNewModifyTypeSuccess = createAction(
  '[Wizard Confirmation Step] Create Modify Type Information Step Success',
  props<{ response: ActionResponse }>(),
);

export const createNewModifyTypeFail = createAction(
  '[Wizard Confirmation Step] Create Modify Type Information Step Fail',
  props<{ errorMessage: string }>(),
);
